import { render, staticRenderFns } from "./salesReturns_ec.vue?vue&type=template&id=6e640a85&scoped=true&"
import script from "./salesReturns_ec.vue?vue&type=script&lang=js&"
export * from "./salesReturns_ec.vue?vue&type=script&lang=js&"
import style0 from "./salesReturns_ec.vue?vue&type=style&index=0&id=6e640a85&lang=less&scoped=true&"
import style1 from "./salesReturns_ec.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e640a85",
  null
  
)

component.options.__file = "salesReturns_ec.vue"
export default component.exports